/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The results of the card update request.
 */
export const CardUpdateReason = {
  Unspecified: "unspecified",
  AccountClosed: "account-closed",
  ContactCardholder: "contact-cardholder",
  ExpirationUpdate: "expiration-update",
  NoChange: "no-change",
  NoMatch: "no-match",
  NumberUpdate: "number-update",
} as const;
/**
 * The results of the card update request.
 */
export type CardUpdateReason = ClosedEnum<typeof CardUpdateReason>;

/** @internal */
export const CardUpdateReason$inboundSchema: z.ZodNativeEnum<
  typeof CardUpdateReason
> = z.nativeEnum(CardUpdateReason);
/** @internal */
export const CardUpdateReason$outboundSchema: z.ZodNativeEnum<
  typeof CardUpdateReason
> = CardUpdateReason$inboundSchema;
